import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
/**
 * @param {HTMLElement} element
 */

export function useAutocomplete(element) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAutofill = _useState2[0],
      setIsAutofill = _useState2[1];

  var onAnimationStart = function onAnimationStart(e) {
    if (e.animationName.includes('onautofillstart')) {
      setIsAutofill(true);
    } else {
      setIsAutofill(false);
    }
  };

  useEffect(function () {
    if (element) {
      element.addEventListener('animationstart', onAnimationStart, true);
    }

    return function () {
      if (element) {
        element.removeEventListener('animationstart', onAnimationStart, true);
      }
    };
  }, [element]);
  return {
    isAutofill: isAutofill
  };
}